export const ROOT_REGION_NAME = 'root' as const;
